import { PermissionNumber } from '@domains/person/user/self/data';

export interface DxPermissionGuardConfig {
  permissions: PermissionNumber[];
  translationKey: string;
  /**
   * Pre-resolved title/message. When set, they are rendered as-is instead of
   * translating `TEMPORARY_AUTH_MODAL.PERMISSION_GUARD.<translationKey>.*`.
   * Callers use this when the copy needs interpolation the grid can't do —
   * e.g. the tenant's person noun, resolved via `PersonNounService`.
   */
  title?: string;
  message?: string;
}

export const DX_PERMISSION_GUARD_CONFIG_TOKEN = Symbol('DX_PERMISSION_GUARD_CONFIG_TOKEN');
